import { Table, Text } from '@nimbus-ds/components';
import { useSelector } from 'react-redux';
import { RootStateType } from 'App/store';
import { CurrencyPrice } from 'commons/components';
import { dateFormat, Format } from 'commons/utils/date';
import { getAbandonedCartsListItemById } from 'domains/Orders/AbandonedCart/abandonedCartsSlice/abandonedCartsSelectors';
import {
  AbandonedCartsSendEmail,
  LinkWithIcon,
  AbandonedCartsListCustomerName,
} from 'domains/Orders/AbandonedCart/pages/AbandonedCartsListPage/components';

interface DraftOrderListHeaderDesktopProps {
  id: string;
}

function AbandonedCartsListDesktopRow({
  id,
}: DraftOrderListHeaderDesktopProps) {
  const abandonedCarts = useSelector((state: RootStateType) =>
    getAbandonedCartsListItemById(state, id),
  );

  const paymentCount = abandonedCarts.paymentCount ?? 0;

  return (
    <Table.Row id="id">
      <Table.Cell>
        <LinkWithIcon
          id={abandonedCarts.id}
          opportunity={abandonedCarts.opportunity}
          paymentIntents={paymentCount}
        />
      </Table.Cell>
      <Table.Cell>
        <Text>{dateFormat(abandonedCarts.date, Format.DAY_MONTH)}</Text>
      </Table.Cell>
      <Table.Cell>
        <CurrencyPrice
          currency={abandonedCarts.currency}
          price={abandonedCarts.total}
        />
      </Table.Cell>
      <Table.Cell>
        <AbandonedCartsListCustomerName abandonedCart={abandonedCarts} />
      </Table.Cell>
      <Table.Cell>
        <Text>{abandonedCarts.customer.email}</Text>
      </Table.Cell>
      <Table.Cell>
        <AbandonedCartsSendEmail abandonedCart={abandonedCarts} />
      </Table.Cell>
    </Table.Row>
  );
}

export default AbandonedCartsListDesktopRow;
